var map = {
	"./cn/about.json": [
		51998,
		1998
	],
	"./cn/academy.json": [
		59842,
		9842
	],
	"./cn/campaign.json": [
		81126,
		1126
	],
	"./cn/column.json": [
		36641,
		6641
	],
	"./cn/events.json": [
		48317,
		8317
	],
	"./cn/flash.json": [
		46621,
		6621
	],
	"./cn/footer.json": [
		40666,
		666
	],
	"./cn/header.json": [
		26183,
		6183
	],
	"./cn/index.json": [
		11970,
		1970
	],
	"./cn/knowledge.json": [
		66520,
		6520
	],
	"./cn/modal.json": [
		57000,
		7000
	],
	"./cn/news.json": [
		44093,
		4093
	],
	"./cn/podcast.json": [
		65962,
		5962
	],
	"./cn/policy.json": [
		69412,
		9412
	],
	"./cn/project.json": [
		24001,
		4001
	],
	"./cn/search.json": [
		5353,
		5353
	],
	"./tw/about.json": [
		56562,
		6562
	],
	"./tw/academy.json": [
		37020,
		7020
	],
	"./tw/campaign.json": [
		10826,
		826
	],
	"./tw/column.json": [
		72783,
		2783
	],
	"./tw/events.json": [
		22275,
		2275
	],
	"./tw/flash.json": [
		80702,
		702
	],
	"./tw/footer.json": [
		34869,
		4869
	],
	"./tw/header.json": [
		25185,
		5185
	],
	"./tw/index.json": [
		21136,
		1136
	],
	"./tw/knowledge.json": [
		30822,
		822
	],
	"./tw/modal.json": [
		84267,
		4267
	],
	"./tw/news.json": [
		68109,
		8109
	],
	"./tw/podcast.json": [
		19249,
		9249
	],
	"./tw/policy.json": [
		25081,
		5081
	],
	"./tw/project.json": [
		39269,
		9269
	],
	"./tw/search.json": [
		67480,
		7480
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 90492;
module.exports = webpackAsyncContext;